import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import styles from './Stack.module.css.js';
import { Base } from '../../Internal/Base/Base.js';
import { justifyMap, alignMap } from '../Inline/Inline.js';

const Stack = ({ space, children, className, fullHeight = false, justify = 'start', align = 'normal', ...restProps }) => {
    const justifyContent = justifyMap[justify];
    const alignItems = alignMap[align];
    const stackClassName = clsx(styles.stack, className, space && styles[space], alignItems, justifyContent, fullHeight && styles.fullHeight);
    return (jsxRuntimeExports.jsx(Base, { className: stackClassName, ...restProps, children: children }));
};
Stack.displayName = 'Stack';

export { Stack };
//# sourceMappingURL=Stack.js.map
